<script>
import VsLayout from './VsLayout';

export default {
  components: {
    VsLayout,
  },
  props: {
    icon: String,
    text: String,
    disabled: Boolean,
    processing: Boolean,
    form: String,
    type: String,
    large: [String, Boolean],
    small: [String, Boolean],
    fullWidth: [String, Boolean],
    notVisible: [String, Boolean],
    appendToInput: [String, Boolean],
    inverse: [String, Boolean],
    alternate: [String, Boolean],
    singleLineButton: [String, Boolean],
  },
  computed: {
    classes() {
      return {
        'vs-button--large': this.large,
        'vs-button--small': this.small,
        'vs-button--full-width': this.fullWidth,
        'vs-button--not-visible': this.notVisible,
        'vs-button--append-to-input': this.appendToInput,
        'vs-button--inverse': this.inverse,
        'vs-button--disabled': this.disabled,
        'vs-button--alternate-colors': this.alternate,
        'vs-button--single-line': this.singleLineButton,
      };
    },
    iconClasses() {
      let classes = {
        'vs-button__icon--visible': this.icon && !this.processing,
      };

      if (this.icon) classes[`mdi-${this.icon}`] = true;

      return classes;
    },
    textClasses() {
      return {
        'vs-button__text--visible': !this.processing,
      };
    },
    buttonType() {
      let type;

      if (this.form) {
        type = 'submit';
      } else if (this.type) {
        type = this.type;
      } else {
        type = 'button';
      }

      return type;
    },
  },
  methods: {
    emitClick(e) {
      if (this.buttonType !== 'submit' && !this.disabled) {
        this.$emit('click');
      } else if (this.disabled) {
        e.preventDefault();
      }
    },
    preventKeydown(e) {
      if (this.buttonType !== 'submit' && !this.disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
  },
};
</script>

<template lang='pug'>
button.vs-button(
  :class='classes',
  :type='buttonType',
  :form='form',
  :aria-disabled='disabled ? "true" : "false"',
  :aria-busy='processing',
  @click='emitClick',
  @keydown.enter='preventKeydown',
  @keyup.enter='emitClick',
)
  vs-layout(auto-xs, vert-align-center-xs, horz-align-center-xs, no-gutter)
    span.vs-button__icon.mdi(v-show='icon', :class='iconClasses')
    span.vs-button__text(v-html='text', :class='textClasses')
    span.vs-button__loader.mdi.mdi-loading.mdi-loading--button(v-show='processing')
</template>